export default __webpack_public_path__ + "e6770a325ed8eb484ce20026a1cb4da8.svg";